"use client";
import React from "react";
import VideoPopup from "../modal/popup-video";
import ModalProvider from "../modal/modal-provider";
import { hexToRgba } from "@/utils";
import { useLanguage } from "@/app/[lang]/client/language-context";
import { getLocalizedPath } from "@/utils/language";

type IProps = {
  cls?: string;
  children: React.ReactNode;
  videoId?: string;
  vimeoPlayer?: boolean;
  buttonColor: string;
  home?: boolean;
};

export default function VideoProvider({
  cls = "",
  children,
  videoId,
  vimeoPlayer,
  buttonColor,
  home,
}: IProps) {
  const [isVideoOpen, setIsVideoOpen] = React.useState(false);
  const { language } = useLanguage();

  return (
    <>
      {home ? (
        <a
          aria-label="video"
          href={getLocalizedPath("/tour-at-htu", language)}
          className={`popup-video ${cls}`}
          style={
            buttonColor
              ? { background: hexToRgba(buttonColor, 0.2), color: buttonColor }
              : undefined
          }
          onMouseEnter={(e) => {
            e.currentTarget.style.background = buttonColor;
            e.currentTarget.style.color = "#ffffff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = hexToRgba(buttonColor, 0.2);
            e.currentTarget.style.color = buttonColor;
          }}
        >
          {children}
        </a>
      ) : (
        <button
          aria-label="video"
          onClick={() => {
            setIsVideoOpen(true);
          }}
          className={`popup-video ${cls}`}
          style={
            buttonColor
              ? { background: hexToRgba(buttonColor, 0.2), color: buttonColor }
              : undefined
          }
          onMouseEnter={(e) => {
            e.currentTarget.style.background = buttonColor;
            e.currentTarget.style.color = "#ffffff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = hexToRgba(buttonColor, 0.2);
            e.currentTarget.style.color = buttonColor;
          }}
        >
          {children}
        </button>
      )}
      <ModalProvider>
        <VideoPopup
          isVideoOpen={isVideoOpen}
          onHide={() => setIsVideoOpen(false)}
          videoId={`${videoId ? videoId : "Ke3715hxISs"}`}
          vimeoPlayer={vimeoPlayer}
        />
      </ModalProvider>
    </>
  );
}
